"use client";

import Link from "next/link";
import HeadingSize from "@/components/ui/HeadingSize";
import CtaButton from "../ui/CtaButton";
import ResponsivePicture from "../ui/ResponsivePicture";

export default function TimeToSection() {
  return (
    <section className="py-4 px-4 sm:py-12 md:py-16 bg-white">
      <div className="hidden lg:block text-center mb-16 md:mb-6 lg:mb-16">
        <div className="mt-8">
          <HeadingSize text="It's time to take small steps" />
        </div>
        <HeadingSize text="that lead to a big impact!" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 w-full">
        {/* Mobile Image */}
        <div className="relative lg:hidden max-w-full">
          <ResponsivePicture
            baseSrc="/images/time-to"
            alt="Taking small steps"
            width={500}
            height={500}
            className="max-w-[360px] w-full mx-auto sm:rounded-xl md:rounded-2xl"
          />
        </div>

        {/* Mobile Heading */}
        <div className="lg:hidden font-['Ainslie_Sans'] font-[600] text-[#000000] text-center flex flex-col">
          <HeadingSize text="It's time to take small steps" />
          <HeadingSize text="that lead to a big impact!" />
        </div>

        {/* Content */}
        <div className="space-y-4 sm:space-y-5 md:space-y-6 text-center lg:text-start px-8 lg:pl-44">
          <p className="text-[black] text-base sm:text-xl sm:mt-12 md:mt-32 md:text-[28px] 2xl:text-[36px] leading-relaxed lg:text-[24px] md:leading-tight lg:text-start">
            Bad habits can lead to negative outcomes in your life – from
            personal to professional to family life. So, it is essential to move
            towards getting rid of them, and we are here along with you in your
            journey
          </p>
          <Link href="/pages/nrt" aria-label="Learn more about NRT">
            <div className="mt-4">
              <CtaButton
                ctaText="Read more"
                dataTestId="read-more-cta-home-page"
              />
            </div>
          </Link>
        </div>

        {/* Desktop Image */}
        <div className="hidden relative lg:block overflow-hidden">
          <ResponsivePicture
            baseSrc="/images/time-to-web"
            alt="Taking small steps"
            width={500}
            height={500}
            className="w-full relative top-0 -right-16"
          />
        </div>
      </div>
    </section>
  );
}
